import PatientBundle from './PatientBundle';

export default PatientBundle;
